import { Group, Text } from "components/common"
import { useTranslation } from "react-i18next"

const MktgCallSummary = ({ callDetail }) => {
  const { t } = useTranslation()
  const summaryDetail = callDetail?.summary
  return (
    <Group gap="24px">
      <div>{summaryDetail?.description}</div>
      <Group template="40% 60%" gap="20px">
        <div>
          <Text type={"secondary"}>{t("Proposed Lead Qualification Status")}</Text>
          <div className="semiBold">{summaryDetail?.status}</div>
        </div>
        <div>
          <Text type={"secondary"}>{t("Interest Level")}</Text>
          <div className="semiBold">{summaryDetail?.level}</div>
        </div>
      </Group>
    </Group>
  )
}

export default MktgCallSummary
